// extracted by mini-css-extract-plugin
module.exports = {"company":"zP6hYnLT8MGWUw25Mq7z5","paragraph":"_3ZcZy68PU8xJNlyVl_7Qp4","comapniesLogos":"e9BehModtawLlelO7QnfE","logo":"_1TY5mpV49iOehFxL0fNChA","row":"_39lqPCk38Bqv1ysu5UyOKg"};